// @ts-nocheck -- inherited from lift-teams; pre-existing type issues outside this port's scope
import { Alert, Tool, Brand, CommunicationMethod } from '../types';

export const dummyTools: Tool[] = [
  {
    id: '1',
    name: 'EMQ',
    description: 'Email Marketing Quality tool for monitoring email performance',
    available: true,
  },
  {
    id: '2',
    name: 'Taxonomy',
    description: 'Data taxonomy and categorization tool',
    available: true,
  },
  {
    id: '3',
    name: 'Pacing',
    description: 'Goal and target pacing monitoring',
    available: true,
  },
  {
    id: '4',
    name: 'CRM',
    description: 'Customer Relationship Management tool',
    available: true,
  },
  {
    id: '5',
    name: 'Data Pipeline',
    description: 'Data pipeline monitoring and alerts',
    available: true,
  },
];

export const dummyBrands: Brand[] = [
  {
    id: '1',
    name: '1800Flowers.com',
    domain: '1800flowers.com',
    logo: 'https://storage.googleapis.com/ltp-static-data/ltp-analytics-cient/brands/1800flowers.png',
  },
  {
    id: '2',
    name: 'Annie Selke',
    domain: 'annieselke.com',
    logo: 'https://storage.googleapis.com/ltp-static-data/ltp-analytics-cient/brands/annieselke.png',
  },
  {
    id: '3',
    name: 'Blue Apron',
    domain: 'blueapron.com',
    logo: 'https://storage.googleapis.com/ltp-static-data/ltp-analytics-cient/brands/blueapron.png',
  },
  {
    id: '4',
    name: 'Casper',
    domain: 'casper.com',
    logo: 'https://storage.googleapis.com/ltp-static-data/ltp-analytics-cient/brands/casper.png',
  },
];

export const dummyCommunicationMethods: CommunicationMethod[] = [
  {
    id: '1',
    type: 'Slack',
    selected: false,
  },
  {
    id: '2',
    type: 'Email',
    selected: false,
  },
  {
    id: '3',
    type: 'LIFT notifications for a Brand',
    selected: false,
  },
  {
    id: '4',
    type: 'LIFT notifications for a user',
    selected: false,
  },
];

export const dummyAlerts: Alert[] = [
  {
    id: '1',
    creator: 'Isabella Thomas',
    creatorAvatar: 'https://storage.googleapis.com/ltp-static-data/drawer-icons/internal%20user.svg',
    toolName: 'EMQ',
    brandName: '1800Flowers.com',
    dateTime: '02/11/2022, 22:45:43',
    status: 'Active',
    alertMessage: 'Annie Selke Age Bidslt is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters, as opposed to',
    threshold: 85,
    communicationMethods: [
      { id: '1', type: 'Slack', selected: true },
      { id: '2', type: 'Email', selected: true },
    ],
    selectedMembers: ['@channel', 'isabella.thomas@company.com'],
    cadence: 'Immediate',
    createdAt: '2022-11-02T22:45:43Z',
    updatedAt: '2022-11-02T22:45:43Z',
  },
  {
    id: '2',
    creator: 'Isabella Thomas',
    creatorAvatar: 'https://storage.googleapis.com/ltp-static-data/drawer-icons/internal%20user.svg',
    toolName: 'EMQ',
    brandName: '1800Flowers.com',
    dateTime: '02/11/2022, 22:45:43',
    status: 'Active',
    alertMessage: 'Annie Selke Age Bidslt is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters, as opposed to',
    threshold: 75,
    communicationMethods: [
      { id: '2', type: 'Email', selected: true },
      { id: '3', type: 'LIFT notifications for a Brand', selected: true },
    ],
    selectedMembers: ['john.doe@company.com', 'alerts@company.com'],
    cadence: 'Daily',
    createdAt: '2022-11-02T22:45:43Z',
    updatedAt: '2022-11-02T22:45:43Z',
  },
  {
    id: '3',
    creator: 'Isabella Thomas',
    creatorAvatar: 'https://storage.googleapis.com/ltp-static-data/drawer-icons/internal%20user.svg',
    toolName: 'EMQ',
    brandName: '1800Flowers.com',
    dateTime: '02/11/2022, 22:45:43',
    status: 'Active',
    alertMessage: 'Annie Selke Age Bidslt is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters, as opposed to',
    threshold: 90,
    communicationMethods: [
      { id: '1', type: 'Slack', selected: true },
    ],
    selectedMembers: ['@alerts', '@team-leads'],
    cadence: 'Weekly',
    createdAt: '2022-11-02T22:45:43Z',
    updatedAt: '2022-11-02T22:45:43Z',
  },
  {
    id: '4',
    creator: 'Isabella Thomas',
    creatorAvatar: 'https://storage.googleapis.com/ltp-static-data/drawer-icons/internal%20user.svg',
    toolName: 'EMQ',
    brandName: '1800Flowers.com',
    dateTime: '02/11/2022, 22:45:43',
    status: 'Active',
    alertMessage: 'Annie Selke Age Bidslt is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters, as opposed to',
    threshold: 80,
    communicationMethods: [
      { id: '2', type: 'Email', selected: true },
      { id: '3', type: 'LIFT notifications for a Brand', selected: true },
    ],
    selectedMembers: ['manager@company.com'],
    cadence: 'Immediate',
    createdAt: '2022-11-02T22:45:43Z',
    updatedAt: '2022-11-02T22:45:43Z',
  },
  {
    id: '5',
    creator: 'Isabella Thomas',
    creatorAvatar: 'https://storage.googleapis.com/ltp-static-data/drawer-icons/internal%20user.svg',
    toolName: 'EMQ',
    brandName: '1800Flowers.com',
    dateTime: '02/11/2022, 22:45:43',
    status: 'Active',
    alertMessage: 'Annie Selke Age Bidslt is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters, as opposed to',
    threshold: 70,
    communicationMethods: [
      { id: '1', type: 'Slack', selected: true },
      { id: '2', type: 'Email', selected: true },
      { id: '3', type: 'LIFT notifications for a Brand', selected: true },
    ],
    selectedMembers: ['@channel', 'team@company.com', 'alerts@company.com'],
    cadence: 'Hourly',
    createdAt: '2022-11-02T22:45:43Z',
    updatedAt: '2022-11-02T22:45:43Z',
  },
  {
    id: '6',
    creator: 'Isabella Thomas',
    creatorAvatar: 'https://storage.googleapis.com/ltp-static-data/drawer-icons/internal%20user.svg',
    toolName: 'EMQ',
    brandName: '1800Flowers.com',
    dateTime: '02/11/2022, 22:45:43',
    status: 'Active',
    alertMessage: 'Annie Selke Age Bidslt is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters, as opposed to',
    threshold: 95,
    communicationMethods: [
      { id: '2', type: 'Email', selected: true },
    ],
    selectedMembers: ['admin@company.com'],
    cadence: 'Daily',
    createdAt: '2022-11-02T22:45:43Z',
    updatedAt: '2022-11-02T22:45:43Z',
  },
  {
    id: '7',
    creator: 'Isabella Thomas',
    creatorAvatar: 'https://storage.googleapis.com/ltp-static-data/drawer-icons/internal%20user.svg',
    toolName: 'EMQ',
    brandName: '1800Flowers.com',
    dateTime: '02/11/2022, 22:45:43',
    status: 'Active',
    alertMessage: 'Annie Selke Age Bidslt is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters, as opposed to',
    threshold: 60,
    communicationMethods: [
      { id: '1', type: 'Slack', selected: true },
      { id: '3', type: 'LIFT notifications for a Brand', selected: true },
    ],
    selectedMembers: ['@alerts', 'notifications@company.com'],
    cadence: 'Weekly',
    createdAt: '2022-11-02T22:45:43Z',
    updatedAt: '2022-11-02T22:45:43Z',
  },
  {
    id: '8',
    creator: 'Isabella Thomas',
    creatorAvatar: 'https://storage.googleapis.com/ltp-static-data/drawer-icons/internal%20user.svg',
    toolName: 'EMQ',
    brandName: '1800Flowers.com',
    dateTime: '02/11/2022, 22:45:43',
    status: 'Active',
    alertMessage: 'Annie Selke Age Bidslt is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters, as opposed to',
    threshold: 88,
    communicationMethods: [
      { id: '1', type: 'Slack', selected: true },
      { id: '2', type: 'Email', selected: true },
    ],
    selectedMembers: ['@team', 'team-lead@company.com'],
    cadence: 'Immediate',
    createdAt: '2022-11-02T22:45:43Z',
    updatedAt: '2022-11-02T22:45:43Z',
  },
];

// Generate more dummy data to reach 1,250 items
export const generateDummyAlerts = (count: number = 1250): Alert[] => {
  const baseAlerts = [...dummyAlerts];
  const additionalAlerts: Alert[] = [];
  
  for (let i = 9; i <= count; i++) {
    const randomTool = dummyTools[Math.floor(Math.random() * dummyTools.length)];
    const randomBrand = dummyBrands[Math.floor(Math.random() * dummyBrands.length)];
    const randomStatus = ['Active', 'Inactive', 'Paused'][Math.floor(Math.random() * 3)] as 'Active' | 'Inactive' | 'Paused';
    const randomThreshold = Math.floor(Math.random() * 40) + 60; // 60-100
    const randomCadence = ['Immediate', 'Hourly', 'Daily', 'Weekly'][Math.floor(Math.random() * 4)];
    
    additionalAlerts.push({
      id: i.toString(),
      creator: 'Isabella Thomas',
      creatorAvatar: 'https://storage.googleapis.com/ltp-static-data/drawer-icons/internal%20user.svg',
      toolName: randomTool.name,
      brandName: randomBrand.name,
      dateTime: '02/11/2022, 22:45:43',
      status: randomStatus,
      alertMessage: 'Annie Selke Age Bidslt is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters, as opposed to',
      threshold: randomThreshold,
      communicationMethods: dummyCommunicationMethods.filter(() => Math.random() > 0.5),
      selectedMembers: ['@channel', 'user@company.com'],
      cadence: randomCadence,
      createdAt: '2022-11-02T22:45:43Z',
      updatedAt: '2022-11-02T22:45:43Z',
    });
  }
  
  return [...baseAlerts, ...additionalAlerts];
};